/**
 * Environment utility class for detecting development mode and other environment states
 */
class Environment {
    /**
     * Check if the application is running in development mode
     * @returns {boolean}
     */
    static isDevelopment() {
        return (
            process.env.NODE_ENV === "development" ||
            process.env.MIX_APP_ENV === "local" ||
            window.location.hostname === "localhost" ||
            window.location.hostname.includes("dev") ||
            window.location.hostname.includes("local") ||
            window.location.hostname.includes("test")
        );
    }

    /**
     * Check if the application is running in production mode
     * @returns {boolean}
     */
    static isProduction() {
        return (
            process.env.NODE_ENV === "production" &&
            process.env.MIX_APP_ENV === "production"
        );
    }

    /**
     * Check if the application is running in testing mode
     * @returns {boolean}
     */
    static isTesting() {
        return (
            process.env.NODE_ENV === "testing" ||
            process.env.MIX_APP_ENV === "testing"
        );
    }

    /**
     * Get the current environment name
     * @returns {string}
     */
    static getEnvironment() {
        if (this.isDevelopment()) return "development";
        if (this.isTesting()) return "testing";
        if (this.isProduction()) return "production";
        return "unknown";
    }

    /**
     * Check if we should bypass theme requirements (development only)
     * @returns {boolean}
     */
    static shouldBypassThemeRequirement() {
        return this.isDevelopment();
    }

    /**
     * Check if we should show development warnings/messages
     * @returns {boolean}
     */
    static shouldShowDevMessages() {
        return this.isDevelopment();
    }
}

export default Environment;
